import i18n from "i18next";

import type { DurationUnit } from "api/services/content/schemas/shared";

export function translateDurationUnit(durationUnit: DurationUnit): string {
  const keyMap: Record<DurationUnit, string> = {
    minutes: i18n.t("library.exercises.fields.duration_unit_options.minutes"),
    repetitions: i18n.t("library.exercises.fields.duration_unit_options.repetitions"),
    repetitions_twice: i18n.t("library.exercises.fields.duration_unit_options.repetitions_twice"),
    seconds: i18n.t("library.exercises.fields.duration_unit_options.seconds"),
    steps: i18n.t("library.exercises.fields.duration_unit_options.steps"),
  };

  return keyMap[durationUnit] || "";
}
